import { extractRemoteItems } from './adminShopProducts';

export function normalizeStyleCode(value: unknown) {
  return typeof value === 'string' ? value.trim() : '';
}

function normalizeStyleCodeKey(value: unknown) {
  return normalizeStyleCode(value).toLowerCase();
}

export function extractStyleCodesFromItemsPayload(payload: unknown) {
  const seenStyleCodes = new Set<string>();

  return extractRemoteItems(payload).flatMap((item) => {
    const styleCode = normalizeStyleCode(item.style ?? item.style_code ?? item.styleCode);
    if (!styleCode) {
      return [];
    }

    const styleCodeKey = normalizeStyleCodeKey(styleCode);
    if (seenStyleCodes.has(styleCodeKey)) {
      return [];
    }

    seenStyleCodes.add(styleCodeKey);
    return [styleCode];
  }).sort((left, right) => left.localeCompare(right, undefined, { sensitivity: 'base', numeric: true }));
}

export function extractStyleCodesFromManageCategoriesPayload(payload: unknown) {
  if (typeof payload !== 'object' || payload === null || Array.isArray(payload)) {
    return [];
  }

  const rawStyles = (payload as Record<string, unknown>).styles;
  if (!Array.isArray(rawStyles)) {
    return [];
  }

  const seenStyleCodes = new Set<string>();

  return rawStyles.flatMap((entry) => {
    const styleCode = normalizeStyleCode(entry);
    if (!styleCode) {
      return [];
    }

    const styleCodeKey = normalizeStyleCodeKey(styleCode);
    if (seenStyleCodes.has(styleCodeKey)) {
      return [];
    }

    seenStyleCodes.add(styleCodeKey);
    return [styleCode];
  }).sort((left, right) => left.localeCompare(right, undefined, { sensitivity: 'base', numeric: true }));
}

export function isStyleCodeTaken(value: unknown, styleCodes: string[], allowedStyleCodes: string[] = []) {
  const normalizedValue = normalizeStyleCode(value);
  if (!normalizedValue) {
    return false;
  }

  const allowedStyleCodeKeys = new Set(
    allowedStyleCodes.map((styleCode) => normalizeStyleCodeKey(styleCode)).filter(Boolean)
  );
  const normalizedValueKey = normalizeStyleCodeKey(normalizedValue);
  if (allowedStyleCodeKeys.has(normalizedValueKey)) {
    return false;
  }

  return styleCodes.some((styleCode) => normalizeStyleCodeKey(styleCode) === normalizedValueKey);
}
